import React from 'react';
import { openIntercomChat } from 'utils/openIntercomChat';
import Welcome from 'modules/Onboarding/components/Welcome';
import { IconArrowForward, IconCheckCircle } from '@capitalise/ui-design-system';
import CreditScoreGuy from 'assets/svgs/credit-score-guy.svg';
import ImageTitleDescription from 'components/ImageTitleDescription';
import GrowFundingGirl from 'assets/svgs/grow-funding-girl.svg';
import InviteTeam from 'modules/Onboarding/components/InviteTeam';
import AccountSetupImage from 'assets/svgs/account-setup.svg';
import AccountSetup from 'modules/Onboarding/components/AccountSetup';
import SearchClientAlpha from 'modules/MonitorWizzard/containers/SearchClientAlpha/SearchClientAlpha';
import { SearchClientProvider } from 'modules/MonitorWizzard/hooks/useSearchClientContext';
import Toast from 'modules/Business/components/Toast';
import FlyingColleagues from 'assets/svgs/flying-colleagues.svg';

export default ({ completeOnboarding, sendInviteSignup, renderToaster }) => [
  {
    label: 'Welcome',
    lead: 'We’re excited to have you onboard, because together we can build a better future for small businesses.',
    title: 'Hello!',
    component: Welcome,
    iconButton: null,
    nextButtonLabel: 'Continue to onboarding',
  },
  {
    lead: 'Get started in your practice with a powerful business finance partnership. Experian powered credit scores to help with pre-funding checks and monitoring financial health.',
    label: 'Insights',
    title: 'Insights and credit scores for your clients!',
    component: ImageTitleDescription,
    hasPrevious: true,
    image: CreditScoreGuy,
    iconButton: IconArrowForward,
  },
  {
    lead: 'Help get your clients funding-ready by preparing their applications. Then submit - with our support - to over 100+ lenders through our marketplace to secure offers of finance for your clients.',
    label: 'Funding',
    title: 'Funding - made easy with specialist support',
    component: ImageTitleDescription,
    hasPrevious: true,
    image: GrowFundingGirl,
    iconButton: IconArrowForward,
  },
  {
    label: 'Add clients',
    fullComponent: {
      component: SearchClientAlpha,
      componentProps: {
        title: 'Add your first client to see their credit profile',
        showPurchaseCredits: false,
        skipDisable: true,
        infoAlertText:
          'Only non-personal and publicly available data will be retrieved so permission is not required to be requested by your client.',
      },
      wrapper: SearchClientProvider,
    },
    nextButtonAction: (callSuccess) => {
      if (callSuccess) {
        renderToaster(<Toast icon={IconCheckCircle} text="Clients added successfully" />);
      }
    },
  },
  {
    label: 'Invite Team',
    title: 'Do more with colleagues',
    component: ImageTitleDescription,
    hasPrevious: true,
    image: FlyingColleagues,
    iconButton: IconArrowForward,
    lead: "Invite a member of your team to share the benefits with them. Enter their e-mail and we'll invite them to your account.",
    children: <InviteTeam />,
    asyncCustomNextFunction: sendInviteSignup,
  },
  {
    label: 'All Set',
    title: "You're all set!",
    component: ImageTitleDescription,
    hasPrevious: true,
    image: AccountSetupImage,
    iconButton: null,
    lead: "Invite a member of your team to share the benefits with them. Enter their e-mail and we'll invite them to your account.",
    children: (
      <AccountSetup
        onButtonClick={() => {
          openIntercomChat();
          completeOnboarding();
        }}
      />
    ),
    nextButtonAction: () => {
      completeOnboarding();
    },
    nextButtonLabel: 'Done',
    isLastStep: true,
  },
];
